import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $accountSettignsModalTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('modal_window_to_account_settings'),
  buttonTitle: t('button_go_to_account_settings'),
}))
